import requestSender from "./base/requestSender";

export default function(axiosInstance){
    return {
        getCallByClientId(payload){
            return requestSender('get', 'organization/get-call-by-client-id', payload);
        },
    }
}